import { Skeleton } from '@mantine/core';

export default function ChapterSkeleton() {
  return <Skeleton className="w-full h-40" radius="md" />;
}
